import styled from "styled-components";

import media from "../theme/rwd";

const StatisticsLayout = styled('div')`
  width: 100%;
  display: grid;
  grid-template-areas:
  "filters" 
  "chart";
  grid-row-gap: 2rem;
  margin-left: auto;
  margin-right: auto;
  padding: 4rem 2rem;
  ${media.lg`
    grid-template-areas: "filters chart";
    grid-template-columns: 3fr 7fr;
    grid-column-gap: 2rem;
    grid-row-gap: 0;
  `}
  ${media.xl`
    grid-template-columns: 2fr 6fr;
  `}
`;

export default StatisticsLayout;
